import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, enumField, DateTimeField } from './util';
import { GameLogBase } from './game-log-base';
import { GameUser } from './game-user';

export enum VolleyballGameLogType {
  enter_game = 1,
  exit_game,
  remove_game,
  serve_hit,
  serve_fault,
  serve_ace,
  stuff_block,
  block_fault,
  block_rebound,
  attack_spike,
  attack_fault,
  attack_shot,
  receive,
  receive_fault,
  excellent_receive,
  point,
  fault,
  serve_receive,
  serve_receive_fault,
  excellent_serve_receive,
  timeout,
  yellow_card,
  tie_ball,
  good_serve
}

export const SCORE_LOG_TYPES = [
  VolleyballGameLogType.serve_ace, VolleyballGameLogType.stuff_block,
  VolleyballGameLogType.attack_spike, VolleyballGameLogType.point
];
export const FAULT_LOG_TYPES = [
  VolleyballGameLogType.serve_fault, VolleyballGameLogType.attack_fault,
  VolleyballGameLogType.block_fault, VolleyballGameLogType.receive_fault,
  VolleyballGameLogType.fault, VolleyballGameLogType.serve_receive_fault
];

@ModelInstance({
  mappingFields: {
    id: 'id',
    unique_id: 'uniqueId',
    game_id: 'gameId',
    game_user_id: 'gameUserId',
    log_type: 'logType',
    set: 'set',
    rally: 'rally',
    position: 'position',
    team_id: 'teamId',
    datetime: 'datetime',
    is_highlight: 'isHighlight',
    group: 'group',
    is_coach: 'isCoach',
    is_bench: 'isBench',
  },
  relation: {
    logType: enumField(VolleyballGameLogType),
    datetime: DateTimeField
  }
})
export class VolleyballGameLog extends BaseModel implements GameLogBase {
  id: number;
  uniqueId: string;
  active = true;
  gameId: number;
  gameUserId: number;
  logType: VolleyballGameLogType;
  set: number;
  rally: number;
  position: number;
  teamId: number;
  datetime: Date;
  isHighlight: boolean;
  gameUser: GameUser;
  group: string;
  isCoach: boolean;
  isBench: boolean;

  compare(model: VolleyballGameLog): number {
    const orderFields = ['set', 'rally', 'datetime', 'id'];
    for (const field of orderFields) {
      if (this[field] < model[field]) {
        return 1;
      }
      if (this[field] > model[field]) {
        return -1;
      }
    }
    return 0;
  }

  isScoreType() {
    return SCORE_LOG_TYPES.includes(this.logType);
  }

  isFaultType() {
    return FAULT_LOG_TYPES.includes(this.logType);
  }

  isServe() {
    return [
      VolleyballGameLogType.serve_hit,
      VolleyballGameLogType.serve_ace,
      VolleyballGameLogType.serve_fault,
      VolleyballGameLogType.good_serve,
    ].includes(this.logType);
  }

  isAttack() {
    return [
      VolleyballGameLogType.attack_fault,
      VolleyballGameLogType.attack_spike,
      VolleyballGameLogType.attack_shot
    ].includes(this.logType);
  }

  isReceive() {
    return [
      VolleyballGameLogType.receive_fault,
      VolleyballGameLogType.receive,
      VolleyballGameLogType.excellent_receive
    ].includes(this.logType);
  }

  isServeReceive() {
    return [
      VolleyballGameLogType.serve_receive_fault,
      VolleyballGameLogType.serve_receive,
      VolleyballGameLogType.excellent_serve_receive
    ].includes(this.logType);
  }

  isBlock() {
    return [
      VolleyballGameLogType.block_fault,
      VolleyballGameLogType.block_rebound,
      VolleyballGameLogType.stuff_block
    ].includes(this.logType);
  }

  isEnterExit() {
    return [
      VolleyballGameLogType.enter_game,
      VolleyballGameLogType.exit_game,
      VolleyballGameLogType.timeout
    ].includes(this.logType);
  }

  isComboType() {
    return ![
      VolleyballGameLogType.receive,
      VolleyballGameLogType.serve_receive
    ].includes(this.logType);
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
